/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect } from 'react';
import { PrivacyPolicy } from 'components/templates/privacy-policy';
import { LANGUAGE_OPTIONS, SUSTAIN_OPTION_LIST } from 'libs/constants';
import { withRouter, NextRouter } from 'next/router';

interface MediaPageProps {
  router: NextRouter;
  lang: string;
}

const MediaPage: React.FC<MediaPageProps> = ({ router, lang }) => {
  // const router = useRouter();

  useEffect(() => {
    if (router) {
      router.push(`/${lang}/privacy-policy/sustainability`, undefined, {
        scroll: false,
      });
    }
  }, [router, lang]);

  const handleOptionSelected = useCallback(
    (tab: number) => {
      const optionList = SUSTAIN_OPTION_LIST as any;
      if (optionList[tab]) {
        const optionItem = optionList[tab] as any;
        router.push(`/${lang}${optionItem.link}`, undefined, {
          scroll: false,
        });
      }
    },
    [lang, router]
  );
  return <PrivacyPolicy onOptionSelected={handleOptionSelected} />;
};

export default withRouter(MediaPage);

export async function getStaticPaths() {
  // generate path for static generation
  const paths: any = [];
  LANGUAGE_OPTIONS.forEach((item: any) => {
    paths.push({
      params: {
        lang: item.value,
      },
    });
  });
  return { paths, fallback: false };
}

export async function getStaticProps(args: any) {
  const { lang } = args.params;

  return {
    props: {
      lang,
    },
  };
}
